import { ApiError } from '@platform/api-client';
import type { Operation, RequestBody, ResponseBody } from '@platform/openapi';

export type CustomerList = ResponseBody<Operation<'/admin/customers', 'get'>>;
export type Customer = CustomerList['items'][number];
export type CustomerBody = RequestBody<Operation<'/admin/customers', 'post'>>;

export const ORDERS_WRITE_ROLE = 'orders:write';
export const PII_READ_ROLE = 'orders:pii:read';

export type CustomerFilters = {
  readonly governorate: string | null;
  readonly city: string | null;
};

const PHONE_TAKEN = 'ORDERS_CUSTOMER_PHONE_TAKEN';

export const phoneHolderOf = (error: unknown): string | null => {
  if (!(error instanceof ApiError) || error.code !== PHONE_TAKEN) return null;
  const holder = error.details['customerId'];
  return typeof holder === 'string' ? holder : null;
};

export const canEdit = (customer: Customer | null, canWrite: boolean): boolean =>
  canWrite && (customer === null || customer.piiVisible);
